/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-13 09:27:31
 */
export default {
  namespaced: true,
  state: {
    isShowGuide: true
  },
  mutations: {
    showGuide (state) {
      state.isShowGuide = true
    },
    hideGuide (state) {
      state.isShowGuide = false
    }
  },
  actions: {
    dispatchShowGuide ({ commit }) {
      commit('showGuide')
    },
    dispatchHideGuide ({ commit }) {
      commit('hideGuide')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/guide.js